import React, { useEffect, useRef, useState, useMemo } from "react";
import { IconBriefcase, IconPhoneCall, IconCoffee, IconCake, IconUsersGroup, IconDroplet, } from "@tabler/icons-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/navigation'; 
import { pageClass } from "../../Components/Utils/CustomClasses";
import { GetUserStatusAPI } from "../../API/Api";
import { useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";
import Greetings from "../../Components/Settings/Greetings/Greetings";

const EmployeeStatus = () => {


  const userDetails = useSelector((state) => state?.login?.userDetails);
  const AUTOPLAY_DELAY = 5000;
  const [selectedTab, setSelectedTab] = useState(0);
  const [statusDatas, setStatusDatas] = useState({});
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);


  const statusData = [
    {
      icon: IconBriefcase,
      label: "Working",
      count: statusDatas?.Working,
      color: "bg-green-500",
      border: "border-green-500",
      bgLight: "bg-green-100",
      text: "text-green-700",
    },
    {
      icon: IconPhoneCall,
      label: "Call",
      count: statusDatas?.Call,
      color: "bg-cyan-500",
      border: "border-cyan-500",
      bgLight: "bg-cyan-100",
      text: "text-cyan-700",
    },
    {
      icon: IconCoffee,
      label: "Tea",
      count: statusDatas?.Tea,
      color: "bg-[#E6B505]",
      border: "border-yellow-500",
      bgLight: "bg-yellow-100",
      text: "text-yellow-700",
    },
    {
      icon: IconCake,
      label: "Lunch",
      count: statusDatas?.Lunch,
      color: "bg-orange-500",
      border: "border-orange-500",
      bgLight: "bg-orange-100",
      text: "text-orange-700",
    },
    {
      icon: IconUsersGroup,
      label: "Meeting",
      count: statusDatas?.Meeting,
      color: "bg-purple-500",
      border: "border-purple-500",
      bgLight: "bg-purple-100",
      text: "text-purple-700",
    },
    {
      icon: IconDroplet,
      label: "Loo",
      count: statusDatas?.Loo,
      color: "bg-blue-500",
      border: "border-blue-500",
      bgLight: "bg-blue-100",
      text: "text-blue-700",
    },
  ];

  const swiperRef = useRef(null);
  const lastSlideTimeoutRef = useRef(null);
  const employeeStatus = async () => {
    try {
      setLoading(true);
      const res = await GetUserStatusAPI({
        p: 1,
        records: 1000,
        userId: userDetails?._id,
        companyId: userDetails?.company?._id,
        statusType: statusData[selectedTab]?.label, 
      });
      setStatusDatas(res?.data?.filteredData?.count);
      const mapped = res?.data?.filteredData?.records.map((r) => ({
        id: r?._id,
        name: `${r?.userId?.first_name} ${r?.userId?.last_name}`,
        role: r?.userId?.role?.roleName,
        status: statusData[selectedTab]?.label,
        callCount: r?.userId?.totalCallCount,
        callTime: r?.userId?.totalCallTime
      }));
      setEmployeeData(mapped);
    }catch (err) {
      console.log("API Error:", err);
    }finally {
    setLoading(false);  
  }
  }
  useEffect(() => {
    employeeStatus();
  }, [selectedTab]);

  const slides = useMemo(() => {
  const chunks = [];
  for (let i = 0; i < employeeData?.length; i += 9) {
    chunks.push(employeeData?.slice(i, i + 9));
  }
  return chunks;
}, [employeeData]);

  const goToNextTab = () => {  
    setSelectedTab((prev) => (prev + 1) % statusData.length);
  };

  const clearLastSlideTimeout = () => {
    if (lastSlideTimeoutRef.current) {
      clearTimeout(lastSlideTimeoutRef.current);
      lastSlideTimeoutRef.current = null;
    }
  };

  const handleSlideChange = (swiper) => {
    clearLastSlideTimeout();

    if (slides.length === 0) {
      goToNextTab();
      return;
    }

    const currentIndex = swiper.realIndex ?? swiper.activeIndex;

    if (currentIndex === slides.length - 1) {
      lastSlideTimeoutRef.current = setTimeout(() => {
        lastSlideTimeoutRef.current = null;
        goToNextTab();
      }, AUTOPLAY_DELAY + 50);
    }
  };


  useEffect(() => {
    clearLastSlideTimeout();

    if (swiperRef.current) {
      try {
        swiperRef.current.slideTo(0, 0);
      } catch (e) {
        console.log("Swiper slideTo error:", e);}
      if (swiperRef.current.autoplay) {
        swiperRef.current.autoplay.stop();
        setTimeout(() => {
          try {
            swiperRef.current.autoplay.start();
          } catch (e) {}
        }, 5000);
      }
    }
  }, [selectedTab]);

  useEffect(() => {
    return () => {
      clearLastSlideTimeout();
    };
  }, []);

  const handleAutoplayTick = () => {
  if (slides.length <= 1) {
    goToNextTab();
  }
};

  return (
    <>
      <div className={`${pageClass} `}>
        <Greetings/>
      </div>
      <div className={`${pageClass} `}>
        <div className="bg-[#FDFDFD] p-10 rounded-xl">
          <h1 className="text-3xl tv:text-4xl tv4k:text-6xl font-bold text-gray-900 mb-6">
            Employee Status
          </h1>

          {/* Status tabs */}
          <div className=" grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 tv:gap-8 tv4k:gap-12 mb-8 ">
            
            {statusData?.map((status, index) => {
              const Icon = status.icon;
              const isActive = selectedTab === index;

              return (
                <button
                  key={index}
                  onClick={() => {
                    clearLastSlideTimeout();
                    setSelectedTab(index);
                  }}
                  className={`rounded-xl w-full px-4 py-4 min-h-[140px] flex flex-col items-center gap-3 transition
  ${
    isActive
      ? `border-[1px] ${statusData[index].border} ${statusData[index].bgLight}`
      : `bg-white border-[1px] border-[#C1C1C1]`
  }`}
                >
                  <div className="flex items-center justify-between w-[100px]">
                    <div
                      className={`${statusData[index].color} flex items-center justify-center 
    w-[64px] h-[64px] rounded-[8.72px]`}
                    >
                      <Icon className="w-[34px] h-[34px] text-white" />
                    </div>

                    <p className="w-[16px] h-[39px] text-[32px] font-semibold leading-[140%] text-[#525252] text-center">
                      {status.count ?? 0}
                    </p>
                  </div>

                  <p className="w-[98px] h-[28px] text-[24px] font-semibold leading-[140%] text-[#171717] text-center">
                    {status.label}
                  </p>
                </button>
              );
            })}
          </div>

          {/* Swiper: multiple slides (each slide = 9 cards in 3x3) */}
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: AUTOPLAY_DELAY, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            onAutoplay={handleAutoplayTick}
            onSlideChange={(swiper) => handleSlideChange(swiper)}
            loop={false}
          >
            {loading ? (
              <div className="flex items-center justify-center bg-[#F0F4F8] w-full h-full">
                <p className="p-10 text-center text-[#404040] text-2xl">
                  Loading
                  <span>
                    <PulseLoader color="#101010" size={5} />
                  </span>
                </p>
              </div>
            ) : employeeData?.length > 0 ? (
              <Swiper
                className="employee-inner-swiper"
                modules={[Autoplay, Pagination]}
                autoplay={{
                  delay: AUTOPLAY_DELAY,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                }}
                onAutoplay={handleAutoplayTick}
                onSlideChange={(swiper) => handleSlideChange(swiper)}
                loop={false}
              >
                {slides.map((group, slideIdx) => (
                  <SwiperSlide key={slideIdx}>
                    <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 tv:grid-cols-4 tv4k:grid-cols-4 gap-4 tv:gap-8 tv4k:gap-12 p-4 tv:p-8 tv4k:p-12 w-full h-full bg-[#F0F4F8] ">
                      {group?.map((emp, idx) => (
                        <div
                          key={idx}
                          className="bg-white rounded-xl border-[1px] flex items-center min-h-[120px] lg:min-h-[140px] tv:min-h-[200px] tv4k:min-h-[260px] px-4 tv:px-6 tv4k:px-8 py-3 tv:py-6 tv4k:py-8"
                        >
                          <div className="flex items-center justify-around w-full">
                            <div className="relative">
                              <div
                                className={` w-14 h-14 md:w-16 md:h-16 tv:w-24 tv:h-24 tv4k:w-32 tv4k:h-32 rounded-full border-2 flex items-center justify-center ${statusData[selectedTab].color} `}
                              >
                                <p className=" text-lg md:text-xl tv:text-4xl tv4k:text-5xl font-bold text-white ">
                                  {" "}
                                  {emp?.name?.[0]}{" "}
                                </p>
                              </div>
                              <div
                                className={`absolute left-1/2 -translate-x-1/2 bottom-[-15px] min-w-[80px] px-1 py-[2px]  tv:-bottom-5 tv4k:-bottom-7 px-2 tv:px-4 tv4k:px-6 py-[2px] tv:py-1 tv4k:py-2 rounded-full border ${statusData[selectedTab].bgLight} ${statusData[selectedTab].text} ${statusData[selectedTab].border}`}
                              >
                                <p className="text-center text-sm font-medium tv:text-2xl tv4k:text-3xl">
                                  {emp?.status}
                                </p>
                              </div>
                            </div>
                            <div className="p-3">
                              <p className="text-base font-bold text-gray-500 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                Name:{" "}
                                <span className="block max-w-[260px] tv:max-w-[360px] tv4k:max-w-[520px] truncate text-base font-bold text-gray-900 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                  {" "}
                                  {emp?.name ?? "----"}{" "}
                                </span>
                              </p>
                              <p className="text-base font-bold text-gray-500 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                Role:{" "}
                                <span className="text-base font-bold text-gray-900 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                  {" "}
                                  {emp?.role ?? "----"}{" "}
                                </span>
                              </p>
                              <p className="text-base font-bold text-gray-500 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                Call Count:{" "}
                                <span className="text-base font-bold text-gray-900 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                  {" "}
                                  {emp?.callCount ?? "----"}{" "}
                                </span>
                              </p>
                              <p className="text-base font-bold text-gray-500 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                Call Time:{" "}
                                <span className="text-base font-bold text-gray-900 tv:text-2xl tv4k:text-4xl tv4k:leading-[50px]">
                                  {emp?.callTime ?? "----"}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="w-full h-full bg-[#F0F4F8] flex items-center justify-center">
                {statusData[selectedTab]?.label === "Working" ||
                statusData[selectedTab]?.label === "Call" ? (
                  <>
                    <p className="text-4xl tv:text-2xl tv4k:text-5xl font-semibold text-[#99A3BE] text-center p-10 font-bold font-serif">
                      No one is {statusData[selectedTab]?.label}
                    </p>
                  </>
                ) : (
                  <>
                    <p className="text-4xl tv:text-2xl tv4k:text-5xl font-semibold text-[#99A3BE] text-center p-10 font-bold font-serif">
                      No one in {statusData[selectedTab]?.label} break
                    </p>
                  </>
                )}
              </div>
            )}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default EmployeeStatus;